import { Transform } from 'class-transformer';
import { DateUtil } from '@shared/util/date.util';
import { Mood } from '@data/mood/Mood';

export class MoodDTO {
  public mood: Mood;

  @Transform(DateUtil.dateConversion)
  public date: Date;
}